// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3OPFD","name":"Header_name__RnHql","birthday":"Header_birthday__1TqzS","skeleton":"Header_skeleton__2BQzm"};